module.exports = __webpack_public_path__ + "media/metronic/_theme/media/files/zip-f1f54315487ce0f75bb88fb75cb901c1.svg";